import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';


i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    ns: ['translation', 'common', 'currency', 'faq', 'pricing'],
    fallbackLng: 'en',
    debug: false,
    interpolation: { escapeValue: false, },
    supportedLngs: ['en'],
    whitelist: ['en'],
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      lookupFromPathIndex: 0,
      checkWhitelist: true
    },
  });

export default i18n;